import styled from 'styled-components'

import { helpers } from 'styles'

export const IconWrapper = styled.div`
	position: absolute;
	right: ${helpers.spacing.xSmall};
	top: ${helpers.spacing.xSmall};
	bottom: ${helpers.spacing.xSmall};
	width: 36px;
	border-radius: 2px;
	background-color: ${helpers.color.inputIconBackground};
	display: flex;
	align-items: center;
	justify-content: center;
`
